<template>
  <ActivitiesHeader /> 
  <ActivitiesBody />
</template>
  
<script>
  import ActivitiesHeader from '../molecules/ActivitiesHeader.vue'
  import ActivitiesBody from '../molecules/ActivitiesBody.vue'
  
  export default {
    name: 'ActivitiesView',
    components: {
      ActivitiesHeader,
      ActivitiesBody
    }
  }
</script>
  